import * as React from "react";

export const CheckMark=()=> <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 34.061 27.175">
  <g id="Group_47" data-name="Group 47" transform="translate(-165.489 -587.529) rotate(9)">
    <rect id="Rectangle_45" data-name="Rectangle 45" width="19.082" height="7.929" rx="3.964" transform="translate(262 561.757) rotate(34)" fill="#228b22"/>
    <rect id="Rectangle_46" data-name="Rectangle 46" width="29.429" height="7.928" rx="3.964" transform="matrix(0.545, -0.839, 0.839, 0.545, 267.155, 574.682)" fill="#228b22"/>
  </g>
</svg> ;


// WEBPACK FOOTER //
// ./src/components/guide/components/CheckMarkSvg.tsx